/**
 * UTM campaign capture for the Shopify Forms "Sign Up Popup".
 *
 * Goal: tag each newsletter subscriber with the Google Ads campaign they came
 * from. We read `utm_campaign` from the landing URL, persist it, and write it
 * into the hidden "campaign" custom field on the Shopify Forms popup so that a
 * Shopify Flow can turn it into a customer tag (e.g. candle / jewellery).
 *
 * The popup is rendered by <shopify-forms-embed> inside a shadow DOM, so the
 * field is hidden and filled via JS (theme CSS cannot pierce the shadow root).
 * The custom field input id is "custom#campaign" (derived from the field label).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'mb_campaign';
  var COOKIE_DAYS = 30;
  var MAX_LEN = 100;
  var FIELD_SELECTOR = '[id="custom#campaign"]';

  // --- 1. Capture utm_campaign on landing and persist it -------------------
  function persistFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var campaign = params.get('utm_campaign');
      if (!campaign) return;
      campaign = campaign.trim().slice(0, MAX_LEN);
      if (!campaign) return;
      try { sessionStorage.setItem(STORAGE_KEY, campaign); } catch (e) {}
      var expires = new Date();
      expires.setTime(expires.getTime() + COOKIE_DAYS * 24 * 60 * 60 * 1000);
      document.cookie =
        STORAGE_KEY + '=' + encodeURIComponent(campaign) +
        ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
    } catch (e) {}
  }

  function getCampaign() {
    try {
      var v = sessionStorage.getItem(STORAGE_KEY);
      if (v) return v;
    } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)mb_campaign=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // --- 2. React-safe value setter (Shopify Forms is React-controlled) ------
  function setReactValue(input, value) {
    var proto = window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // --- 3. Hide the campaign field + fill it when the popup renders ----------
  function processForms() {
    var campaign = getCampaign();
    var embeds = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < embeds.length; i++) {
      var sr = embeds[i].shadowRoot;
      if (!sr) continue;
      var input = sr.querySelector(FIELD_SELECTOR);
      if (!input) continue;
      // Always hide the field so organic visitors never see it.
      var wrap = input.closest('[class*="_formFieldContainer_"]') || input.parentElement;
      if (wrap && wrap.style.display !== 'none') wrap.style.display = 'none';
      // Fill only when we actually have a campaign value.
      if (campaign && input.value !== campaign) setReactValue(input, campaign);
    }
  }

  // --- 4. Init: shadow DOM mutations don't bubble, so poll lightly ----------
  function init() {
    processForms();
    // The popup mounts lazily (teaser -> expand) and can remount, so re-apply
    // on a light interval. querySelector calls are cheap.
    var ticks = 0;
    var timer = setInterval(function () {
      processForms();
      ticks++;
      if (ticks > 600) clearInterval(timer); // ~10 min safety cap
    }, 1000);
  }

  persistFromUrl();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
